import axios from "axios";
import { DMI_FINANCE_APIS } from "../config/ApiConfig";

export const fetchPlanList = () =>
  axios(DMI_FINANCE_APIS.GET_PLAN_URL, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

export const fetchBrandList = () =>
  axios(DMI_FINANCE_APIS.GET_BRAND_LIST_URL, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

export const saveDmiDetails = (payload) =>
  axios(DMI_FINANCE_APIS.SAVE_DMI_DETAILS_URL, {
    method: "POST",
    data: payload,
    headers: { "Content-Type": "application/json" },
  });

export const sendPaymentRequest = (payload) =>
  axios(DMI_FINANCE_APIS.SEND_DMI_PAYMENT_REQUEST_URL, {
    method: "POST",
    data: payload,
    headers: { "Content-Type": "application/json" },
  });

export const fetchPaymentStatus = (userId) =>
  axios(`${DMI_FINANCE_APIS.GET_DMI_PAYMENT_STATUS_URL}?UserId=${userId}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

export const sendPolicyCallback = (payload) =>
  axios(DMI_FINANCE_APIS.POLICY_CALLBACK_URL, {
    method: "POST",
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer IERDVjczNjM4WTIzN0RHSERTREZHSENDSTk5ODc0UjczOEU5V0RJSkJFV1lZQ0hE",
    },
  });
